export default {
  analytics: 'Countries: {countries} | Groups: {groups} | Operators: {operators}',

  hints: {
    tree: {
      country: 'country',
      operator: 'operator',
      group: 'group',
      groupsCount: 'Groups: {groups}',
      operatorsCount: 'Operators: {operators}',
      mcc: 'MCC',
      mnc: 'MNC'
    }
  },

  snackbars: {
    created: 'Group created',
    updated: 'Group updated',
    removed: 'Group removed'
  },

  contents: {
    confirm: {
      remove: 'Are you sure you want to remove group {title}?'
    }
  },

  tabs: {
    all: 'All',
    checked: 'Selected'
  },

  pills: {
    all: 'Available',
    checked: 'Selected'
  },

  errors: {
    mccmnc: {
      dictionary: 'Dictionary for MCC/MNC was not found.<br>Please contact the administrator.'
    }
  }
}
